/**
 * @file tool to dynamically load data from files
 * @author Haonan Yu(haoyu@microStrategy.com)
 */

import * as DEFINITIONS from '../Utils/Constants';
import { linLoadData } from './LinuxDataLoader';
import { winLoadData } from './WindowsDataLoader';

export const loadData = (installation) => {
    switch (installation) {
        case DEFINITIONS.LINUX_11_5_03:
        case DEFINITIONS.LINUX_11_4_12:
        case DEFINITIONS.LINUX_11_4_09:
        case DEFINITIONS.LINUX_11_4_06:
        case DEFINITIONS.LINUX_11_4_03:
        case DEFINITIONS.LINUX_11_3_12:
        case DEFINITIONS.LINUX_11_3_11:
        case DEFINITIONS.LINUX_11_3_10:
        case DEFINITIONS.LINUX_11_3_9:
        case DEFINITIONS.LINUX_11_3_8:
        case DEFINITIONS.LINUX_11_3_7:
        case DEFINITIONS.LINUX_11_3_6:
        case DEFINITIONS.LINUX_11_3_5_2:
        case DEFINITIONS.LINUX_11_3_5_1:
        case DEFINITIONS.LINUX_11_3_5:
        case DEFINITIONS.LINUX_11_3_4_1:
        case DEFINITIONS.LINUX_11_3_4:
        case DEFINITIONS.LINUX_21:
        case DEFINITIONS.LINUX_21_UPDATE1:
        case DEFINITIONS.LINUX_21_UPDATE2:
        case DEFINITIONS.LINUX_21_UPDATE3:
            linLoadData(installation);
            break;

        case DEFINITIONS.WINDOWS_11_5_03_CUSTOM:
        case DEFINITIONS.WINDOWS_11_5_03_EXPRESS:
        case DEFINITIONS.WINDOWS_11_4_12_CUSTOM:
        case DEFINITIONS.WINDOWS_11_4_12_EXPRESS:
        case DEFINITIONS.WINDOWS_11_4_09_CUSTOM:
        case DEFINITIONS.WINDOWS_11_4_09_EXPRESS:
        case DEFINITIONS.WINDOWS_11_4_06_CUSTOM:
        case DEFINITIONS.WINDOWS_11_4_06_EXPRESS:
        case DEFINITIONS.WINDOWS_11_4_03_CUSTOM:
        case DEFINITIONS.WINDOWS_11_4_03_EXPRESS:
        case DEFINITIONS.WINDOWS_11_3_12_CUSTOM:
        case DEFINITIONS.WINDOWS_11_3_12_EXPRESS:            
        case DEFINITIONS.WINDOWS_11_3_11_CUSTOM:
        case DEFINITIONS.WINDOWS_11_3_11_EXPRESS:
        case DEFINITIONS.WINDOWS_11_3_10_CUSTOM:
        case DEFINITIONS.WINDOWS_11_3_10_EXPRESS:
        case DEFINITIONS.WINDOWS_11_3_9_CUSTOM:
        case DEFINITIONS.WINDOWS_11_3_9_EXPRESS:
        case DEFINITIONS.WINDOWS_11_3_8_CUSTOM:
        case DEFINITIONS.WINDOWS_11_3_8_EXPRESS:
        case DEFINITIONS.WINDOWS_11_3_7_CUSTOM:
        case DEFINITIONS.WINDOWS_11_3_7_EXPRESS:
        case DEFINITIONS.WINDOWS_11_3_6_CUSTOM:
        case DEFINITIONS.WINDOWS_11_3_6_EXPRESS:
        case DEFINITIONS.WINDOWS_11_3_5_2_CUSTOM:
        case DEFINITIONS.WINDOWS_11_3_5_2_EXPRESS:
        case DEFINITIONS.WINDOWS_11_3_5_1_CUSTOM:
        case DEFINITIONS.WINDOWS_11_3_5_1_EXPRESS:
        case DEFINITIONS.WINDOWS_11_3_5_CUSTOM:
        case DEFINITIONS.WINDOWS_11_3_5_EXPRESS:
        case DEFINITIONS.WINDOWS_11_3_4_1_CUSTOM:
        case DEFINITIONS.WINDOWS_11_3_4_1_EXPRESS:
        case DEFINITIONS.WINDOWS_11_3_4_CUSTOM:
        case DEFINITIONS.WINDOWS_11_3_4_EXPRESS:
        case DEFINITIONS.WINDOWS_21_CUSTOM:
        case DEFINITIONS.WINDOWS_21_EXPRESS:
        case DEFINITIONS.WINDOWS_21_UPDATE1:
        case DEFINITIONS.WINDOWS_21_UPDATE2:
        case DEFINITIONS.WINDOWS_21_UPDATE3:
            winLoadData(installation);
            break;
        default:
    }
};
